<template>
  <div>
    <div class="search-form">
      <div class="search-form-left">
        <div class="form">
          <a-form-model
            :model="form"
            layout="inline"
          >
            <a-form-model-item
              label="基地："
              prop="baseId"
            >
              <a-select
                v-model="form.baseId"
                placeholder="请选择基地"
                allow-clear
                show-search
                :filter-option="filterOption"
                @inputKeydown="inputKeydown($event, checkResource)"
              >
                <a-select-option
                  v-for="item in baseOptions"
                  :key="item.baseId"
                >
                  {{ item.baseName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item
              label="年度："
              prop="year"
            >
              <a-date-picker
                v-model="form.year"
                mode="year"
                :open="isopen"
                placeholder="请选择年份"
                format="YYYY"
                style="width: 100%;"
                @panelChange="panelChange"
                @openChange="openChangeOne"
              />
            </a-form-model-item>
          </a-form-model>
        </div>
        <div class="ant-btns-mrright">
          <TableActions
            :actions="headerActions"
            @checkResource="checkResource"
            @exportResource="exportData"
          />
        </div>
      </div>
    </div>
    <div class="table">
      <a-table
        :data-source="dataSource"
        :loading="loading"
        :columns="columns"
        :pagination="pagination"
        :expanded-row-keys="openRowKeys"
        :row-key="(item, index) => item.baseId + ''+ item.year"
        :scroll="{ x: 1500 }"
        @expand="handleClickRow"
        @change="handleTableChange"
      >
        <a-table
          slot="expandedRowRender"
          slot-scope="record"
          :columns="innerColumns"
          :data-source="record.innerDataSource"
          :row-key="(item, index1) => index1"
          :pagination="false"
          :show-header="false"
          :loading="loading2"
        />
      </a-table>
    </div>

    <ExportTables
      :visible="exportVisible"
      :loading="confirmLoading"
      @cancel="handleCancel"
      @exportOk="exportOk"
      @monSelected="monSelected"
    />
  </div>
</template>

<script>
import {
  queryYearStatistics, querySubYearStatistics, exportYearStatistics
} from '@/api/dispenseflow.js'
import {
  queryAllProductTypes, queryBases
} from '@/api/common.js'
import ExportTables from '@/components/exportTables/exportTables.vue'
import { excelDown, filterOption, inputKeydown } from '@/utils/utils.js'
import { pagination } from '@/constants/tableSetting'

const headerActions = [
  {
    title: '查询',
    type: 'primary',
    action: 'checkResource'
  },
  {
    title: '导出',
    type: 'primary',
    action: 'exportResource',
    apis: ['@baseInfo/Export_Bases']

  }
]

const innerColumns = [{
  title: '',
  dataIndex: '',
  key: '',
  width: '160px'
},
{
  title: '年度',
  dataIndex: 'yearMonth',
  key: 'yearMonth'
}
]
export default {
  components: {
    ExportTables
  },
  data () {
    return {
      columns: [],
      pagination,
      innerColumns,
      baseOptions: [],
      dataSource: [],
      dataSourceTempt: [],
      productTypesTempt: [],
      innerDataSource: [],
      loading: true,
      form: {
        baseId: undefined,
        year: undefined
      },
      headerActions,
      isopen: false,
      exportVisible: false,
      confirmLoading: false,
      loading2: true,
      openRowKeys: [],
      monthOptions: []
    }
  },
  mounted () {
    this.fetchData()
    this.fetchSearchOptions()
  },
  methods: {
    excelDown,
    filterOption,
    inputKeydown,
    checkResource () {
      this.pagination.current = 1
      this.fetchData()
    },
    async fetchData () {
      this.openRowKeys = []
      this.columns = [
        {
          title: '基地',
          dataIndex: 'baseName',
          key: 'baseName',
          width: '120px'
        },
        {
          title: '时间',
          dataIndex: 'year',
          key: 'year',
          width: '120px'
        }]
      this.innerColumns = [{
        title: '',
        dataIndex: '',
        key: '',
        width: '120px'
      },
      {
        title: '年度',
        dataIndex: 'yearMonth',
        key: 'yearMonth',
        width: '120px'
      }
      ]
      this.loading = true

      await queryAllProductTypes().then((data) => {
        this.productTypesTempt = data
        this.productTypesTempt.map((item) => {
          this.columns.push({
            title: item.productTypeName,
            dataIndex: item.productTypeId,
            key: item.productTypeId,
            width: '120px'
          })
          this.innerColumns.push({
            title: item.productTypeName,
            dataIndex: item.productTypeId,
            key: item.productTypeId,
            width: '120px'
          })
        })
      })
      await queryYearStatistics({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize - 1,
        baseId: this.form.baseId,
        year: this.form.year
      }).then((data) => {
        this.pagination.total = data.totalRecords
        this.totalAmounts = data.totalAmounts ? data.totalAmounts : []
        this.dataSourceTempt = data.result ? data.result : []
        const len = this.dataSourceTempt.length
        this.dataSource = data.result ? data.result : []

        this.dataSourceTempt.map((dataSourceTemptItem, index) => {
          dataSourceTemptItem.productTypes.map((item) => {
            this.$set(this.dataSource[index],
              item.productTypeId,
              item.amount)
          })
        })

        if (len > 0) {
          this.dataSource.push({})
          this.totalAmounts.map((item) => {
            this.$set(this.dataSource[len],
              'year',
              '总计')
            this.$set(this.dataSource[len],
              item.productTypeId,
              item.amount)
          })
        }
      })
      this.loading = false
    },
    async fetchSearchOptions () {
      await queryBases().then((data) => {
        this.baseOptions = data
      })
    },
    handleTableChange (pagination, filters, sorter) {
      this.pagination = { ...this.pagination, ...pagination }
      this.fetchData()// 获取表格数据的接口
    },
    async handleClickRow (expanded, record) {
      if (expanded) {
        this.openRowKeys.push(record.baseId + '' + record.year)
        await querySubYearStatistics({
          baseId: record.baseId,
          year: record.year
        }).then((data) => {
          this.loading2 = true
          record.innerDataSource = data
          this.dataSourceTempt = data
          this.dataSourceTempt.map((item, index) => {
            item.productTypes.map((innerItem) => {
              this.$set(record.innerDataSource[index],
                innerItem.productTypeId,
                innerItem.amount)
            })
          })
          this.loading2 = false
        })
      } else {
        this.openRowKeys.pop(record.baseId + '' + record.year)
      }
    },
    openChangeOne (status) {
      this.isopen = !this.isopen
    },
    panelChange (value) {
      this.isopen = false
      this.form.year = value ? value.format('YYYY') : null
    },
    exportData () {
      this.exportVisible = true
    },
    monSelected (value) {
      this.monthOptions = value
    },
    async exportOk (value) {
      await exportYearStatistics({
        ...this.form,
        subRecord: value,
        yearMonthStart: this.monthOptions[0],
        yearMonthEnd: this.monthOptions[1]
      }).then((data) => {
        this.excelDown(data, '资源发放自然年度统计')
        this.handleCancel()
      })
    },
    handleCancel () {
      this.exportVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-table-tbody tr:last-child td:first-child {
  visibility: hidden;
}
</style>
